const MONTHS = {
  [`01`]: `января`,
  [`02`]: `февраля`,
  [`03`]: `марта`,
  [`04`]: `апреля`,
  [`05`]: `мая`,
  [`06`]: `июня`,
  [`07`]: `июля`,
  [`08`]: `августа`,
  [`09`]: `сентября`,
  [`10`]: `октября`,
  [`11`]: `ноября`,
  [`12`]: `декабря`,
};

export default () => {
  const dateElements = document.querySelectorAll(`.js-date`);
  if (dateElements.length) {
    dateElements.forEach((el) => {
      const date = el.getAttribute(`datetime`).split(`-`);
      if (date) {
        const year = date[0];
        const month = MONTHS[date[1]];
        const day = date[2];
        el.textContent = `${day} ${month} ${year}`;
      }
    });
  }
};
